export enum ETipoControleArea {
    NaoDefinido = 0,
    ConsumoEnergia = 1,
    ControleEquipamento = 2,
}
